import styled from 'styled-components';
import { MAIN_TAB_STATUS } from '../../types/type';
import { MODAL_TYPE, modalStore } from '../../store/modalStore';
import { useDateHook } from '../../hook/useDateHook';
import { infoStore, ParticipationStatus } from '../../store/infoStore';
import { isPc } from '../../utils';
import { mobileQuery } from '../../utils';
import { useEffect } from 'react';

export const InfoTab = ({
  mainTab,
  setMainTab,
}: {
  mainTab: MAIN_TAB_STATUS;
  setMainTab: (n: MAIN_TAB_STATUS) => void;
}) => {
  const { info } = infoStore();
  const { isOpenTabDate, today } = useDateHook();
  const { showModal } = modalStore();
  const isMobile = !isPc();
  const hasTicket = info.status !== ParticipationStatus.NO_TICKETS;

  const switchTab = (mainTabIndex: MAIN_TAB_STATUS) => {
    // 새틀라이트 진행 안내 탭 클릭 시
    if (mainTabIndex === MAIN_TAB_STATUS.PROGRESS) {
      // 아직 탭이 열리지 않은 경우
      if (!isOpenTabDate()) {
        showModal({ modalType: MODAL_TYPE.NOT_START });
        return;
      }
    }

    // 메인 이벤트 참가 안내 클릭 시
    if (mainTabIndex === MAIN_TAB_STATUS.MAIN_EVENT) {
      // 티켓이 없다면 참가권 확인 모달을 띄움
      if (!hasTicket) {
        showModal({ modalType: MODAL_TYPE.CHECK_TICKET });
        return;
      }
    }

    window.scrollTo({ top: 0 });
    setMainTab(mainTabIndex);
  };

  useEffect(() => {
    if (isPc()) {
      setMainTab(MAIN_TAB_STATUS.REWARD);
    } else {
      if (hasTicket && isOpenTabDate()) {
        setMainTab(MAIN_TAB_STATUS.PROGRESS);
        return;
      }

      setMainTab(MAIN_TAB_STATUS.REWARD);
    }
  }, [today, hasTicket]);

  return (
    <TabContainer>
      <Tab
        onClick={() => switchTab(MAIN_TAB_STATUS.REWARD)}
        $isActive={mainTab === MAIN_TAB_STATUS.REWARD}
      >
        <TabText $isActive={mainTab === MAIN_TAB_STATUS.REWARD}>
          토너먼트
          <span>
            <br />
          </span>
          안내
        </TabText>
      </Tab>

      <Tab
        onClick={() => switchTab(MAIN_TAB_STATUS.PARTICIPATE)}
        $isActive={mainTab === MAIN_TAB_STATUS.PARTICIPATE}
      >
        <TabText $isActive={mainTab === MAIN_TAB_STATUS.PARTICIPATE}>참가 안내</TabText>
      </Tab>

      {isMobile && (
        <Tab
          onClick={() => switchTab(MAIN_TAB_STATUS.PROGRESS)}
          $isActive={mainTab === MAIN_TAB_STATUS.PROGRESS}
        >
          <TabText $isActive={mainTab === MAIN_TAB_STATUS.PROGRESS}>새틀라이트</TabText>
        </Tab>
      )}

      {isMobile && (
        <Tab
          onClick={() => switchTab(MAIN_TAB_STATUS.MAIN_EVENT)}
          $isActive={mainTab === MAIN_TAB_STATUS.MAIN_EVENT}
        >
          <TabText $isActive={mainTab === MAIN_TAB_STATUS.MAIN_EVENT}>
            오프라인
            <br /> 이벤트
          </TabText>
        </Tab>
      )}
    </TabContainer>
  );
};

const TabContainer = styled.div`
  display: flex;
  position: relative;
  z-index: 2;
  left: 0px;
  padding-left: 115px;
  padding-right: 115px;

  ${mobileQuery} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Tab = styled.div<{ $isActive: boolean }>`
  height: 68px;
  flex: 1;
  background: ${({ $isActive }) => ($isActive ? '#302e2d' : '#1C1B1B')};
  text-align: center;
  cursor: pointer;
  transition: 0.2s;

  &:last-child {
    margin-right: 0;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 50px;
  }
`;

const TabText = styled.h4<{ $isActive: boolean }>`
  font-family: 'GmarketSans';
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 500)};
  font-size: 22px;
  line-height: 28px;
  color: ${({ $isActive }) => ($isActive ? '#FFF1C9' : '#868686')};
  text-align: center;

  span {
    display: none;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 18px;
    span {
      display: inline;
    }
  }
`;
